import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";

export default function CoppaNotice() {
  const navigate = useNavigate();
  return (
    <div className="min-h-screen bg-[#050505]" data-testid="coppa-page">
      <header className="sticky top-0 z-50 glass-darker border-b border-white/5">
        <div className="max-w-3xl mx-auto px-4 py-4 flex items-center gap-4">
          <button onClick={() => navigate(-1)} className="text-zinc-400 hover:text-white">
            <ArrowLeft size={20} />
          </button>
          <h1 className="font-heading text-xl font-bold text-white">Children's Privacy (COPPA)</h1>
        </div>
      </header>
      <main className="max-w-3xl mx-auto px-4 py-8">
        <div className="prose-invert space-y-6 text-zinc-300 text-sm leading-relaxed">
          <p className="text-zinc-500 text-xs">Last updated: February 2026</p>

          <Section title="Overview">
            Bitcoin Brain takes children's privacy seriously. This notice explains how we comply with the Children's Online Privacy Protection Act (COPPA) for users under 13 years of age.
          </Section>

          <Section title="Kid Mode">
            Bitcoin Brain includes a "Kid Mode" feature designed for younger learners. Kid Mode provides age-appropriate Bitcoin education content including a Sat Budget Simulator and simplified learning materials.
          </Section>

          <Section title="Parental Consent">
            Children under 13 should not create their own Bitcoin Brain account. Instead, a parent or educator should create an account and use the Educator License to link child accounts, or supervise the child's use of Kid Mode through their own account. By linking a child's account through the Educator License, the parent or educator provides verifiable parental consent for the collection of the child's learning data.
          </Section>

          <Section title="What We Collect from Children">
            For linked student accounts (children under 13), we collect only:
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Name (as provided by the parent or educator)</li>
              <li>Email address (as provided by the parent or educator)</li>
              <li>Learning progress (sections completed, quiz scores, BTC XP, badges)</li>
            </ul>
            We do not collect location data, photos, videos, or any other personal information from children.
          </Section>

          <Section title="How We Use Children's Data">
            Children's learning data is used solely to:
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Track educational progress within the Bitcoin Brain course</li>
              <li>Display progress to the linked parent or educator</li>
              <li>Generate printable certificates and progress reports</li>
            </ul>
            We do not use children's data for advertising, profiling, or any purpose other than the educational experience.
          </Section>

          <Section title="Parental Rights">
            Parents and educators have the right to:
            <ul className="list-disc pl-5 space-y-1 mt-2">
              <li>Review their child's personal information and learning data</li>
              <li>Request deletion of their child's account and all associated data</li>
              <li>Refuse further collection of their child's information</li>
              <li>Remove their child's linked account at any time from the Educator Dashboard</li>
            </ul>
          </Section>

          <Section title="Data Security">
            Children's data is stored with the same security protections as all user data. We use encrypted connections and secure database storage. Children's data is never shared with third parties except as necessary for the educational service (e.g., email delivery for account setup).
          </Section>

          <Section title="Contact">
            For questions about children's privacy or to exercise parental rights, email <a href="mailto:bitcoinbrain21m@gmail.com" className="text-[#F7931A] hover:underline">bitcoinbrain21m@gmail.com</a>
          </Section>
        </div>
      </main>
    </div>
  );
}

function Section({ title, children }) {
  return (
    <div>
      <h2 className="text-white font-heading font-bold text-base mb-2">{title}</h2>
      <div>{children}</div>
    </div>
  );
}
